import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

/**
 * 実力テスト志望校判断表（志望校合格力診断）
 */
export namespace ApiTaRe320 {
  // API Name
  export const name: string = 'ApiTaRe320'

  // GET parameters
  export namespace Get {
    export const path: string = '/ta/forecastAchievementPass'

    export interface Request {
      query: {
        fiscalYear: number
        month: number
        times: number
        grade: number
      }
    }

    export interface Response {
      choiceSchoolDetermineListUrl: string
    }
  }

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造
      const validationSample: Get.Response = {
        choiceSchoolDetermineListUrl: '',
      }

      // エラー時のレスポンス構造
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
